/*
 * @Author: Jason
 * @Date: 2019-10-15 17:32:50
 * @version: 
 * @LastEditors: Jason
 * @LastEditTime: 2019-10-31 18:56:01
 * @Descripttion: 
 */
import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import './assets/css/common.scss'
import Mint from 'mint-ui'
import 'mint-ui/lib/style.css'
import BaiduMap from 'vue-baidu-map';
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import VueAwesomeSwiper from 'vue-awesome-swiper'
import 'swiper/dist/css/swiper.css'//这里注意具体看使用的版本是否需要引入样式，以及具体位置。
Vue.use(VueAwesomeSwiper, /* { default global options } */)
Vue.use(ElementUI);
Vue.use(Mint);    
Vue.config.productionTip = false

//AES加解密
import encryption from './assets/js/encryption';
Vue.prototype.$aes = encryption;

//字段加密
import { encryptParams } from './assets/js/encrypt';
Vue.prototype.$encrypt = encryptParams;

import { ls } from './assets/js/utils.js'
router.beforeEach((to, from, next) => {
  // ...
  console.log('即将进入',to,from)
  if(to.meta.isAuth){
    if(ls.getter('loginStatus')){
      next()
    }else{
      next({ path: '/login' })
    }
  }else{
    next()
  }
  
})


let isDebug = false   // 是否测试

const vconsole = ()=>{
    let vcJS = document.createElement('script')
    vcJS.setAttribute('src','https://cdn.bootcss.com/vConsole/3.2.2/vconsole.min.js')
    vcJS.setAttribute('type','text/javascript')
    document.head.appendChild(vcJS)
    vcJS.onload = ()=>{
        let vConsole = new VConsole();
    }
}
if( isDebug ) vconsole()



// 导航离开该组件的对应路由时调用
// 可以访问组件实例 `this`
router.afterEach ((to, from, next)=>{
  Mint.MessageBox.close()
})
Vue.use(BaiduMap, {
  // ak 是在百度地图开发者平台申请的密钥 详见 http://lbsyun.baidu.com/apiconsole/key */
  ak: '3YOCg7ZoHfhOLxtsTDpMVuPs'
});

// 金额保留两位小数
Vue.filter('numToFixed', val => {
  return val ? Number(val).toFixed(2) : val
})
// 格式化手机号码
Vue.filter('phoneHidden', val => {
  try {
    if(val.length>8){
      return val.substr(0,3)+'****'+val.substr(7)
    }else{
      return val
    }
  }catch{
    return ''
  }
  
})


Vue.mixin({
  methods:{
    // 弹出框
    toast(msg,position='middle',duration=3000){
      Mint.Toast({
        message: msg,
        position: position,
        duration: duration
      });
    },
    // 加载loading
    openloading(msg='加载中...',type='fading-circle'){
      Mint.Indicator.open({
        text:msg,
        spinnerType:type
      })
    },
    // 关闭loading
    closeloading(){
      Mint.Indicator.close();
    }
    
    
  }
})


new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
